import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { WorkflowFormFieldInputDealDetails } from '@workflows/types';
import { FormControl } from '@angular/forms';
import { RequestFormDealDetailsComponent } from '@features/requests';
import { NgClass } from '@angular/common';

@Component({
  selector: 'x-input-deal-details-field',
  imports: [RequestFormDealDetailsComponent, NgClass],
  templateUrl: './input-deal-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputDealDetailsComponent {
  field = input.required<WorkflowFormFieldInputDealDetails>();
  control = input.required<FormControl<string | null>>();
  canExecute = input<boolean>(true);
}
